import { render, staticRenderFns } from "./EducationalGroupTabs.vue?vue&type=template&id=cbcc84e0&"
import script from "./EducationalGroupTabs.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports